import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { CustomerService } from 'app/00_modules/core/services/customer.service';
import { RoleAccessor } from 'app/00_modules/core/services/accessors/user-role/user-role.accessor';
import { CustomerIdAccessor } from 'app/00_modules/core/services/accessors/customer-id.accessor';
import { RouterService } from 'app/00_modules/core/services/router.service';
import { RoleName } from '../00_modules/core/user/RoleName';
import { lastValueFrom } from 'rxjs';
import { CustomerFacade } from '../store/facade/customer.facade';

@Injectable()
export class RoleResolver {
    constructor(
        private roleAccessor: RoleAccessor,
        private customerIdAccessor: CustomerIdAccessor,
        private customerService: CustomerService,
        private routerService: RouterService,
        private customerFacade: CustomerFacade
    ) {}

    public async resolve(route: ActivatedRouteSnapshot): Promise<void> {
        const currentRole = this.roleAccessor.getRoleData().roleId;
        if (currentRole === RoleName.MasterDataManager) {
            this.routerService.navigateToMasterData();
            return;
        }
        if (currentRole === RoleName.ClassicCars) {
            this.routerService.navigateToClassicCars();
            return;
        }
        if (currentRole !== RoleName.OrderRecording) {
            return;
        }

        const customerIdToSet = await this.getCurrentCustomerId(currentRole);
        if (!customerIdToSet) {
            return;
        }
        const selectedCustomer = (await lastValueFrom(this.customerService.getCustomers())).find(c => c.id === customerIdToSet);

        if (!selectedCustomer) {
            throw new Error('Invalid customer id');
        }
        this.customerFacade.setCurrentCustomer(selectedCustomer);
    }

    // Returns customerId if the customer is not in store. If the state has the customerId nothing is returned
    private async getCurrentCustomerId(currentRole: RoleName): Promise<number> {
        let currentCustomerId: number = null;
        if (currentRole !== RoleName.OrderRecording) {
            return currentCustomerId;
        }

        currentCustomerId = await this.customerIdAccessor.getCustomerIdAsync();
        if (currentCustomerId) {
            return currentCustomerId;
        }
        throw new Error('Customer is not set');
    }
}
